export const service = [
  {
    type: "Editorial Service",
    active: [2022],
    organization: "Journal Editor: Dr. Naoko Taguchi",
    role: "Editorial Assistant",
    details: "Applied Pragmatics by John Benjamins Publishing Company",
  },
  {
    type: "Manuscript Reviewer",
    details: "Applied Pragmatics",
  },
  {
    type: "Manuscript Reviewer",
    details: "Instructed Second Language Acquisition",
  },
  {
    type: "Manuscript Reviewer",
    details: "International Journal of Hospitality Management",
  },
  {
    type: "Manuscript Reviewer",
    details: "Research Methods in Applied Linguistics",
  },
  {
    type: "Manuscript Reviewer",
    details: "Studies in Second Language Acquisition",
  },
  {
    type: "Manuscript Reviewer",
    details: "Studies in Second Language Learning and Teaching",
  },
  {
    type: "Manuscript Reviewer",
    details: "Text and Talk",
  },
  {
    type: "Abstract Reviewer",
    active: [2022],
    organization: "American Association of Corpus Linguistics (AACL)",
    role: "",
    details:
      "15th International American Association of Corpus Linguistics Conference",
  },
  {
    type: "Abstract Reviewer",
    active: [2021],
    organization: "Graduate Student Association of Applied Linguistics (GSAAL)",
    role: "",
    details: "Graduate Student Association of Applied Linguistics Conference",
  },
  {
    type: "Abstract Reviewer",
    active: [2019],
    organization:
      "Pronunciation in Second Language Learning and Teaching (PSLLT)",
    role: "",
    details:
      "Pronunciation in Second Language Learning and Teaching Conference",
  },
  {
    type: "Conference Organization",
    active: [2022],
    organization:
      "15th International American Association of Corpus Linguistics (AACL)",
    role: "Conference Hosting Team",
    details:
      "15th International American Association of Corpus Linguistics Conference",
  },
  {
    type: "Conference Organization",
    active: [2022],
    organization: "Northern Arizona University",
    role: "Organizing Committee",
    details: "Annual Graduate Poster Symposium",
  },
  {
    type: "Conference Organization",
    active: [2022],
    organization: "AAAL Graduate Student Council",
    role: "",
    details:
      "AAAL Graduate Student Council Workshop “Finding Your Academic Niche”",
  },
  {
    type: "Conference Organization",
    active: [2022],
    organization: "AAAL Graduate Student Council",
    role: "",
    details: "Webinar: “Exploring External Grants for Graduate Research”",
  },
  {
    type: "Conference Organization",
    active: [2021],
    organization: "Northern Arizona University",
    role: "Organizing Committee",
    details: "Annual Graduate Poster Symposium",
  },
  {
    type: "Conference Organization",
    active: [2021],
    organization: "Graduate Student Association of Applied Linguistics (GSAAL)",
    role: "",
    details: "GSAAL Conference: Building Bridges Through Language Research",
  },
  {
    type: "Conference Organization",
    active: [2021],
    organization:
      "American Association of Applied Linguistics (AAAL) Graduate Student Council",
    role: "",
    details:
      "Pre-Conference Workshop: “Balancing Holistic Experience of Being a Graduate Student”",
  },
  {
    type: "Conference Organization",
    active: [2021],
    organization:
      "American Association of Applied Linguistics (AAAL) Graduate Student Council",
    role: "",
    details:
      "Webinar “Getting Ready for the Academic Job Market: Tips for Developing Materials”",
  },
  {
    type: "Conference Organization",
    active: [2019],
    organization:
      "Pronunciation in Second Language Learning and Teaching (PSLLT)",
    role: "Conference Volunteer",
    details:
      "Pronunciation in Second Language Learning and Teaching (PSLLT) Conference",
  },
  // Grant Reviewer
  {
    type: "Grant Reviewer",
    active: [2021, 2022],
    organization: "Northern Arizona University",
    role: "",
    details: "Northern Arizona University Graduate Student Symposium Award",
  },
  {
    type: "Grant Reviewer",
    active: [2020],
    organization: "Graduate Student Association of Applied Linguistics (GSAAL)",
    role: "",
    details: "GSAAL Conference Grant",
  },
  //  Mentorship & Supervision
  {
    type: "Mentorship & Supervision",
    active: [2020, 2021],
    organization:
      "Provided guidance for four Graduate Teaching Assistants who taught ENG 105",
    role: "Teaching Team Leader",
    details: (
      <>University Writing Program &mdash; Northern Arizona University</>
    ),
  },
  {
    type: "Mentorship & Supervision",
    active: [2018, 2019],
    organization:
      "Supervised two Graduate Teaching Assistants who taught ENG 105",
    role: "Mentor, Supervisor",
    details: (
      <>University Writing Program &mdash; Northern Arizona University</>
    ),
  },
  {
    type: "Professional Affiliations",
    active: [1],
    organization: "American Association of Applied Linguistics (AAAL)",
    link: "https://aaal.org/",
  },
  {
    type: "Professional Affiliations",
    active: [1],
    organization: "Teaching English to Speakers of Other Languages (TESOL)",
    link: "https://www.tesol.org/",
  },
  {
    type: "Professional Affiliations",
    active: [1],
    organization: "American Pragmatics Association (AMPRA)",
    link: "https://pragmatics.international/",
  },
  {
    type: "Professional Affiliations",
    active: [1],
    organization: "International Association for Teaching Pragmatics (IATP)",
    link: "https://www.ub.edu/itap-association/",
  },
  {
    type: "Professional Affiliations",
    active: [1],
    organization: "Learner Corpus Association (LCA)",
    link: "https://learnercorpusassociation.org/",
  },
  {
    type: "Professional Affiliations",
    active: [0],
    organization:
      "International Association of Teachers of English as a Foreign Language (IATEFL)",
    link: "https://iatefl.org/",
  },
  {
    type: "Professional Affiliations",
    active: [0],
    organization:
      "Arizona Association of Teachers of English as a Second Language (AZATESOL)",
    link: "https://www.aztesol.org/",
  },
  {
    type: "Professional Affiliations",
    active: [0],
    organization:
      "American Council on the Teaching of Foreign Languages (ACTFL)",
    link: "https://www.actfl.org/",
  },
  {
    type: "Professional Affiliations",
    active: [0],
    organization: "Linguistics Society of America (LSA)",
    link: "https://www.linguisticsociety.org/",
  },
  // Leadership Positions
  {
    type: "Leadership Positions",
    active: [2021, 2022],
    organization: "Northern Arizona University",
    role: "Co-President",
    details: "L2 Speaking Club",
  },
  {
    type: "Leadership Positions",
    active: [2021, 2022],
    organization: "Northern Arizona University",
    role: "Co-Founder, Organizer",
    details: "Python Club",
  },
  {
    type: "Leadership Positions",
    active: [2021, 2022],
    organization: "Northern Arizona University",
    role: "Vice President of Internal Affairs",
    details: "Graduate Student Government",
  },
  {
    type: "Leadership Positions",
    active: [2020, 2021, 2022],
    organization: "AAAL Graduate Student Council",
    role: "Subcommittee Member",
    details: "AAAL Graduate Student Council - Event Organizing Sub-Committee",
  },
  {
    type: "Leadership Positions",
    active: [2020, 2021],
    organization: "Northern Arizona University",
    role: "Co-President",
    details: "Graduate Student Association of Applied Linguistics (GSAAL)",
  },
  {
    type: "Leadership Positions",
    active: [2019, 2020],
    organization: "Northern Arizona University",
    role: "Treasurer",
    details: "Graduate Student Association of Applied Linguistics (GSAAL)",
  },
  {
    type: "Leadership Positions",
    active: [2017, 2018],
    organization: "Northern Arizona University",
    role: "Social Media Coordinator",
    details: "Graduate English Organization (GEO)",
  },
];

const sortServiceByType = (type) => {
  switch (type) {
    case "Editorial Service":
      return 10000;
    case "Manuscript Reviewer":
      return 9999;
    case "Abstract Reviewer":
      return 9998;
    case "Conference Organization":
      return 9997;
    case "Grant Reviewer":
      return 9996;
    case "Mentorship & Supervision":
      return 9995;
    case "Professional Affiliations":
      return 9994;
    case "Leadership Positions":
      return 9993;
    default:
      return 9992;
  }
};

const sortServiceByActive = (active) => {
  switch (active) {
    case 1:
      return 9999;
    case 0:
      return -1;
    default:
      return Math.max(...active);
  }
};

export const sortService = (a, b) => {
  const sortedByType = sortServiceByType(b.type) - sortServiceByType(a.type);
  if (sortedByType !== 0) {
    return sortedByType;
  }
  const sortedByActive =
    sortServiceByActive(b?.active ?? 1) - sortServiceByActive(a?.active ?? 1);

  return sortedByActive;
};

export default service;
